import React from 'react'

function ChatIcon() {
  return (
    <svg className="icon chatIcon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
      <g fill="none" fillRule="evenodd">
        <g fill="#FFF">
          <g>
            <g>
              <path
                d="M14 3.333c2.21 0 4 1.791 4 4v4c0 2.21-1.79 4-4 4H6.012l-3.09 1.536c-.33.164-.73.03-.893-.3-.065-.129-.085-.275-.059-.417l.53-2.88c-.319-.575-.5-1.235-.5-1.939v-4c0-2.209 1.79-4 4-4h8zm0 1H6c-1.61 0-2.923 1.268-2.997 2.86L3 7.332v4c0 .46.103.902.297 1.304l.077.15.174.313-.474 2.577 2.703-1.344H14c1.61 0 2.923-1.267 2.997-2.858l.003-.142v-4c0-1.61-1.267-2.923-2.859-2.996L14 4.333zM6.667 8.667c.552 0 1 .447 1 1 0 .552-.448 1-1 1-.553 0-1-.448-1-1 0-.553.447-1 1-1zm3.333 0c.552 0 1 .447 1 1 0 .552-.448 1-1 1s-1-.448-1-1c0-.553.448-1 1-1zm3.333 0c.553 0 1 .447 1 1 0 .552-.447 1-1 1-.552 0-1-.448-1-1 0-.553.448-1 1-1z"
                transform="translate(-1056 -20) translate(1048 12) translate(8 8)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default ChatIcon
